var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "services row"
  }, _vm._l((_vm.services), function(service) {
    return _c('div', {
      staticClass: "service-contaner col-md-4 justify-content-center"
    }, [_c('div', {
      staticClass: "service-card"
    }, [_c('div', {
      staticClass: "card-custom-header"
    }, [_c('h2', {
      staticClass: "title"
    }, [_vm._v(_vm._s(service.plan))]), _c('p', {
      staticClass: "great-text"
    }, [_vm._v(_vm._s(service.megas)), _c('span', {
      staticClass: "caption"
    }, [_vm._v("MB")])])]), _c('div', {
      staticClass: "card-content"
    }, [_c('p', {
      staticClass: "price"
    }, [_vm._v("RD$ " + _vm._s(service.price) + " / mes")]), _vm._m(0, true)])])])
  }))
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "btn call-to-action special"
  }, [_vm._v("Seleccionar")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22b7bf2f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/src/components/HomeServices.vue
// module id = 41
// module chunks = 0